import { useSignals } from "@preact/signals-react/runtime";
import { useEffect } from "react";
import { useLocation } from "wouter";

import { sessionUser } from "@/pages/authentication/state/session";
import { updateUsageAnalyticsContext } from "@/shared/utils/usage-analytics";
import { startUserActivityTracking, updateUserActivityCategory } from "@/shared/utils/user-activity";

export default function UsageAnalyticsTracker() {
    useSignals();
    const [location] = useLocation();
    const userID = isPublicRoute(location) ? "" : sessionUser.value?.role === "HAP" ? "" : sessionUser.value?.id ?? "";

    useEffect(() => {
        updateUsageAnalyticsContext(userID, location);
    }, [location, userID]);

    useEffect(() => {
        const category = location.startsWith('/report') ? 'status-report' : location.startsWith('/manage') ? 'manage' : 'other';
        updateUserActivityCategory(category);
    }, [location]);

    useEffect(() => {
        startUserActivityTracking(userID, 'other');
        return () => startUserActivityTracking('', '');
    }, [userID]);

    return null;
}

function isPublicRoute(location: string) {
    const pathname = location.split(/[?#]/, 1)[0] || "/";
    return pathname === "/logout" || pathname === "/hap/entry" || pathname === "/status-report" || pathname === "/telefonist" || pathname === "/bed-board" || pathname === "/external" || pathname.startsWith("/external/");
}
